import { proxy } from "valtio";

export const editrequestapprovalStore = proxy({
quote:{},
editquote:{},
list:[],
pkb:[],
rebate:[],
approve:true
})